<template>
  <div class="event-create">
    <b-container>
      <b-row>
        <b-col>
            <b-form @submit.prevent="submitEvent">
              <b-form-row>
                <div class="form-group col-12">
                  <label for="change-status" v-translate>Area</label>
                  <div class="input-group">
                    <b-form-select multiple v-model="eventAreas" :options="areasSelect" required :select-size="8" v-if="!event.area_id">
                      <template slot="first">
                        <option :value="null" v-translate>Select Area</option>
                      </template>
                    </b-form-select>
                    <b-form-select v-model="event.area_id" :options="areasSelect" required  v-else>
                      <template slot="first">
                        <option :value="null" v-translate>Select Area</option>
                      </template>
                    </b-form-select>
                  </div>
                </div>
                <div class="form-group col-12">
                  <label for="change-status" v-translate>Event Type</label>
                  <div class="input-group">
                    <b-form-select v-model="event.event_type_id" :options="eventTypesSelect" required>
                      <template slot="first">
                        <option :value="null" v-translate>Select Event Type</option>
                      </template>
                    </b-form-select>
                  </div>
                </div>
                <div class="form-group col-12">
                  <label for="change-status" v-translate>Amount</label>
                  <div class="input-group">
                    <b-form-input v-model="event.amount" type="number" required />
                    <b-input-group-append>
                      <b-form-select v-model="event.amount_type" required>
                        <option :value="null" v-translate>Select Amount Type</option>
                        <option value="percentage" v-translate>Percentage</option>
                        <option value="fixed" v-translate>Fixed</option>
                      </b-form-select>
                    </b-input-group-append>
                  </div>
                </div>
                <div class="form-group col-12">
                  <label for="change-status" v-translate>From/To</label>
                  <div class="input-group">
                    <date-range-picker
                      v-if="this.locale.daysOfWeek"
                      v-model="updatedDateRange"
                      :locale-data="locale"
                      :opens="opens"
                      class="mb-2 w-100"
                      :ranges="ranges"
                      @update="updateValues"
                      time-picker
                      :time-picker-increment="30"
                      ref="dateRange"
                       @click="resetupdatedDateRange"
                    >
                      <div slot="input" slot-scope="picker">
                        <font-awesome-icon :icon="['far', 'calendar-alt']" size="1x" style="vertical-align: middle" />
                        <span style="vertical-align: middle">{{moment.utc(event.from_date).tz($tz).format('L LT')}} - {{moment.utc(event.to_date).tz($tz).format('L LT')}}</span>
                      </div>
                    </date-range-picker>
                  </div>
                </div>
              </b-form-row>
              <div class="text-right form-group col-12 form-actions">
                <b-button type="submit" variant="primary" size="lg" v-translate>Set Event</b-button>
                <b-button variant="outline-primary" size="lg" @click.prevent="closeModal('modalEventForm')" v-translate>Cancel</b-button>
              </div>
            </b-form>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import DateRangePicker from 'vue2-daterange-picker'

export default {
  name: 'EventCreate',
  components: {
    DateRangePicker
  },
  props: {
    event: {
      type: Object,
      default: function () {
        return {
          id: null,
          area_id: null,
          event_type_id: null,
          amount: '',
          amount_type: null,
          from_date: null,
          to_date: null,
          active: true
        }
      }
    }
  },
  data() {
    return {
      dismissSecs: 10,
      dismissCountDown: 0,
      eventAreas: [],
      updatedDateRange: { // used for v-model prop
        startDate: this.moment.utc(this.event.from_date).tz(this.$tz).format('YYYY-MM-DD HH:mm:ss'), // .tz(this.$tz) || this.moment(),
        endDate: this.moment.utc(this.event.to_date).tz(this.$tz).format('YYYY-MM-DD HH:mm:ss') // .tz(this.$tz) || this.moment()
      },
      opens: 'left', //  which way the picker opens, default "center", can be "left"/"right"
      locale: {
        direction: 'ltr', //  direction of text
        format: 'dd/mm/yyyy HH:MM', //  fomart of the dates displayed
        separator: ' - ', //  separator between the two ranges
        applyLabel: this.$gettext('Apply'),
        cancelLabel: this.$gettext('Cancel'),
        weekLabel: 'W',
        customRangeLabel: this.$gettext('Custom Range'),
        daysOfWeek: this.moment.weekdaysMin(), // days, //  array of days - see moment documenations for details
        monthNames: this.moment.monthsShort(), //  array of month names - see moment documenations for details
        firstDay: 1,
        showWeekNumbers: false //  show week numbers on each row of the calendar
      },
      ranges: false,
      updatedDateRangeActive: 0
    }
  },
  watch: {
    updatedDateRangeActive: {
      handler (val) {
        if (val !== 0) {
          this.event.from_date = this.moment(this.moment(this.updatedDateRange.startDate).local().format('YYYY-MM-DD HH:mm:ss')).seconds(0).utc().format('YYYY-MM-DD HH:mm:ss')
          this.event.to_date = this.moment(this.moment(this.updatedDateRange.endDate).local().format('YYYY-MM-DD HH:mm:ss')).seconds(0).utc().format('YYYY-MM-DD HH:mm:ss')
        } else {
          this.event.from_date = null
          this.event.to_date = null
        }
      },
      deep: true
    }
  },
  created() {
    this.fetchAreas()
      .then(() => {
        this.fetchEventTypes()
      })
  },
  methods: {
    resetupdatedDateRange() {
      if (this.updatedDateRangeActive === 0) {
        this.updatedDateRange = {
          startDate: this.moment(),
          endDate: this.moment()
        }
        this.updatedDateRangeActive = 0
      }
    },
    updateValues(obj) {
      this.updatedDateRangeActive++
      this.$refs.dateRange.$el.childNodes[0].className = this.$refs.dateRange.$el.childNodes[0].className.replace(' is-invalid', '')
    },
    submitEvent() {
      if (!this.event.from_date || !this.event.to_date) {
        this.$refs.dateRange.$el.childNodes[0].className = this.$refs.dateRange.$el.childNodes[0].className + ' is-invalid'
        return false
      } else {
        if (!this.event.area_id) {
          for (let i = 0; i < this.eventAreas.length; i++) {
            this.event.area_id = this.eventAreas[i]
            this.$http.post(this.$appConfig.api.baseUrl + 'events', this.event)
              .then(response => {
                if (i === this.eventAreas.length) {
                  this.closeModal('modalEventForm')
                }
              })
          }
        } else {
          this.$http.patch(this.$appConfig.api.baseUrl + 'events/' + this.event.id, this.event)
            .then(response => {
              this.closeModal('modalEventForm')
            })
        }
      }
    },
    closeModal(id) {
      this.$root.$emit('bv::hide::modal', id)
    },
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown
    },
    showAlert() {
      this.dismissCountDown = this.dismissSecs
    }
  }
}
</script>
